export default function useProcessLeaderboard(quizMarks, assignmentMarks) {
  if (!quizMarks || !assignmentMarks) return null;

  // Combine marks for each student
  const combineQuizMarks = quizMarks?.reduce((acc, obj) => {
    const existingObj = acc.find((o) => o.student_id === obj.student_id);

    if (existingObj) {
      existingObj.mark += obj.mark;
    } else {
      acc.push({
        student_id: obj.student_id,
        student_name: obj.student_name,
        mark: obj.mark,
      });
    }

    return acc;
  }, []);
  const combineAssignmentMarks = assignmentMarks?.reduce((acc, obj) => {
    const existingObj = acc.find((o) => o.student_id === obj.student_id);

    if (existingObj) {
      existingObj.mark += obj.mark;
    } else {
      acc.push({
        student_id: obj.student_id,
        student_name: obj.student_name,
        mark: obj.mark,
      });
    }

    return acc;
  }, []);

  const transFormedQuiz = combineQuizMarks.map((q) => ({
    student_id: q.student_id,
    name: q.student_name,
    quizMark: q.mark,
    assignmentMark: 0,
    totalMark: q.mark,
  }));

  const mergedData = combineAssignmentMarks.reduce((acc, current) => {
    const itemIndex = acc.findIndex(
      (item) => item.student_id === current.student_id
    );
    if (itemIndex >= 0) {
      acc[itemIndex] = {
        ...acc[itemIndex],
        assignmentMark: current.mark,
        totalMark: current.mark + acc[itemIndex].quizMark,
      };
    } else {
      acc.push({
        student_id: current.student_id,
        name: current.student_name,
        assignmentMark: current.mark,
        quizMark: 0,
        totalMark: current.mark,
      });
    }
    return acc;
  }, transFormedQuiz);

  const sortedData = mergedData?.sort((a, b) => b.totalMark - a.totalMark);

  let currentRank = 1;
  let lastMark = sortedData[0].totalMark;
  const rankedData = sortedData?.map((student) => {
    if (student.totalMark !== lastMark) {
      currentRank++;
    }
    lastMark = student.totalMark;
    return {
      ...student,
      rank: currentRank,
    };
  });

  return rankedData;
}
